<template>
	<div v-if="noWrap"><slot></slot></div>
	<div v-else class="form-group" :class="{
		'is-invalid' : invalid, 
		row: colClass != 'stacked' && !controlLeft,
		'd-flex flex-row align-items-center': controlLeft
	}">
		<label 
			class="col-form-label" 
			:class="labelClass" 
			v-html="stripInlineEventHandlers(label)" 
			v-on:click="$emit('clickLabel')">
		</label>

		<div :class="controlLeft ? '' : fieldClass" 
			:style="{
				order:controlLeft ? -1 : 'default',
			}">
			<slot></slot>
		</div>
	</div>
</template>

<script type="text/javascript">

		export default {
			name: "FormGroup",
			props: [
				"label",
 				"colClass", 
				"invalid",
				"controlLeft", 
				"alignLabelRight",
				"noWrap" //makes form-group invisible
			],
			methods: {
				updateValue(value) {
					this.$emit("input",value)
				}
			},
			computed: {
				labelClass() {
					let labelClass = this.colClass

					if (this.alignLabelRight)
						labelClass += " text-right"

					return labelClass
				},
				fieldClass () {
					//split into classes first
					if (this.colClass == 'col-auto') {
						return 'col-auto'
					}
					else if (this.colClass != "stacked") {
						let classes = this.colClass.split(" ")

						let returnClasses = ""

						classes.forEach(function(cls,index){
							//Compute the field column size from the label column size
							let num_cols_arry = cls.split("-")

							if (num_cols_arry.length == 2) {
								let num_cols = parseInt(num_cols_arry[1])

								let difference_cols = 12 - num_cols

								returnClasses += " col-"+difference_cols
							}
							else {
								let num_cols = parseInt(num_cols_arry[2])

								let difference_cols = 12 - num_cols

								returnClasses += " col-" + num_cols_arry[1] + "-"+difference_cols
							}
						})
						return returnClasses
					}
					else
						return ""
				}
			}
		}
</script>

<style type="text/css">
	.form-group {
		margin-bottom: 0.3rem;
	}

	.col-form-label {
		text-align: left;
		font-weight: 600;
	}

	.form-group.is-invalid {
		background-color: #f2dede;
		padding-top: 5px;
		padding-bottom: 5px;
	}

	.form-group.is-invalid label {
		color: #721c24;
	}

	@media (max-width: 767px) {
		label.col-form-label {
			text-align: left;
		}
	}
</style>